export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-de-DE.9e45302b.xlsx";